import DocumentsContainer from 'containers/Vendors/Documents'
import React, { FC } from 'react'

const VendorDocumentsPage: FC = () => <DocumentsContainer />

export default VendorDocumentsPage
